import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SimIconComponent } from '@simOn/ui/sim-icon';

@Component({
  selector: 'sim-section-heading',
  imports: [SimIconComponent],
  templateUrl: './section-heading.component.html',
  styleUrl: './section-heading.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'section-heading'
  }
})
export class SimSectionHeadingComponent {
  readonly icon = input<string>('');
}
